export function sliderBusinessSupport() {
    if($('body').hasClass('is-desktop')){

        $('#business-support-slider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            dotsClass: 'slick-dots slider__dots',
            customPaging: function (slick, index) {
                var image = $(slick.$slides[index]).find('.slider__img').attr('src');
                return '<img src="' + image + '" alt="" /> '
            }
        });

    }else if(($('body').hasClass('is-mobile') || $('body').hasClass('is-tablet') || $('body').hasClass('is-safari'))) {

        $('#business-support-slider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000
        });

    }
    $('.custom-slider').css('opacity', '1');

}


// WEBPACK FOOTER //
// ./assets/js/modules/sliderBusinessSupport.js